import React, {useState}  from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import {toast} from 'react-toastify'


const AddressForm = ({address, updateAddress,updateEditing}) => {
    let {clinicId} = useParams()
    const [isLoading,setIsLoading] = useState(false)
    const [isError,setIsError] = useState(false)
    const [isSuccess,setIsSuccess] = useState(false)
   // const [address,setAddress] = useState()
    
    const { register, handleSubmit, formState:{errors} } = useForm(
        {
            defaultValues:{
                street:address.street,
                city:address.city,
                province:address.province,
                postalCode:address.postalCode,
                country:address.country
            }
        }
    );
    
    const onSubmit = (data) => {
        setIsLoading(true);
        setIsError(false);
        setIsSuccess(false);
       
           clinicService.addAddress(clinicId,data)
           .then(res => {
            setIsLoading(false);
            setIsSuccess(true);
            console.log(res);
           // setAddress(res.data);
            updateAddress(res.data)
            toast.success("Address Updated",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            })
            .catch(err => {
                setIsLoading(false);
                setIsError(true);
            
            });
      
      
    }

    


    return(
             <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <label className="form-label" htmlFor="street">Street</label>
                    <input 
                        type="text" 
                        className="form-control form-control-sm" 
                       
                        {...register("street", {required:true})}
                    />
                </div>
                <div className="form-group">
                    <label className="form-label" htmlFor="city">City</label>
                    <input 
                        type="text" 
                        className="form-control form-control-sm" 
                        {...register("city", {required:true})}
                        />
                </div>
                <div className="form-group">
                    <label className="form-label" htmlFor="province">Province</label>
                    <input 
                        type="text" 
                        className="form-control form-control-sm" 
                        {...register("province", {required:true})}
                    />
                </div>
                <div className="form-group">
                    <label className="form-label" htmlFor="postalCode">Postal Code</label>
                    <input 
                        type="text" 
                        className="form-control form-control-sm" 
                        {...register("postalCode", {required:true})}
                    />
                </div>
                <div className="form-group">
                    <label className="form-label" htmlFor="country">Country</label>
                    <input 
                        type="text" 
                        className="form-control form-control-sm" 
                        {...register("country", {required:true})}
                    />
                </div>
                <div className='d-flex justify-content-between'>
                    <button type="submit" className="btn btn-secondary btn-sm mt-2">Save</button>
                    <button className='btn btn-secondary btn-sm mt-2' onClick={updateEditing} >Cancel</button>
                </div>
                
         </form>
    )
}
export default AddressForm;